import React, { useContext, useEffect, useState } from "react";
import { HashLoader } from "react-spinners";
import * as api from "../../../service/publicApi";
import { CurrentUserContext } from "../../../App";
import { useNavigate } from "react-router-dom";

export default function LoginThaiD() {
  const navigate = useNavigate();
  const { userRole, setUserRole, setIsMessage } =
    useContext(CurrentUserContext);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getParameter();
  }, []);

  const getParameter = () => {
    let code = new URLSearchParams(window.location.search).get("code");
    // console.log(code)

    if (code) {
      loginThaiD(code);
    } else {
      setIsMessage({ type: "warning", data: "code is require." });
    }
  };

  const loginThaiD = async (code) => {
    setLoading(true);
    let res = await api.loginThaiD(code);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({ type: "success", data: "login success" });
        logedIn(res["data"]);
      } else if (res["data"]["code"] === 404) {
        setIsMessage({
          type: "warning",
          data: "ไม่พบข้อมูลผู้ใช้งาน กรุณาสมัครใช้งานก่อน",
        });
        let data = res["data"]["mohpromt_user_data"];
        let y = data["birthday"].split("-")[0];
        let m = data["birthday"].split("-")[1].padStart(2, "0");
        let d = data["birthday"].split("-")[2].padStart(2, "0");
        navigate("/register", {
          state: {
            type: "register_thaiD",
            pname: data["pname"],
            fname: data["fname"],
            lname: data["lname"],
            pid: data["pid"],
            thaiD: data["thai_d"],
            access_token: data["access_token"],
            yearOB: y,
            monthOB: m,
            dayOB: d,
          },
        });
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const logedIn = (data) => {
    localStorage.setItem(
      "pg_access_token",
      data["user_data"]["auth"]["access_token"],
    );
    localStorage.setItem(
      "expire_login_user",
      data["user_data"]["auth"]["access_token_expire"],
    );
    localStorage.setItem("user", JSON.stringify(data["user_data"]));

    setUserRole(data["user_data"]);

    if (data.user_data.auth.role[0] === "MEDICAL_PERSONNEL") {
      navigate("/doctor/guideline");
    } else if (data.user_data.auth.role[0] === "HOSPITAL_PERSONNEL") {
      navigate("/");
    } else if (data.user_data.auth.role[0] === "LABORATORY_ADMIN") {
      navigate("/inputdata");
    } else if (data.user_data.auth.role[0] === "LABORATORY_PERSONNEL") {
      navigate("/");
    } else if (data.user_data.auth.role[0] === "PATIENT") {
      navigate("/");
    } else if (data.user_data.auth.role[0] === "ADMIN") {
      navigate("/admin");
    } else if (data.user_data.auth.role[0] === "EXECUTIVE") {
      navigate("/manager/aggregateResult");
    } else if (data.user_data.auth.role[0] === "HOSPITAL") {
      navigate("/hospital/setting");
    } else {
      console.log("ยังไม่ได้ทำfunction check role user");
    }
  };

  return (
    <div>
      <HashLoader
        loading={loading}
        style={{ display: "flex", justifyContent: "center" }}
        color="#FF9768"
      />
    </div>
  );
}
